"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchObserverImpl = void 0;
class BranchObserverImpl {
    subject;
    data = [];
    constructor(subject) {
        this.subject = subject;
    }
    getState() {
        return this.data;
    }
    getEventListener() {
        return this.subject.getEventListener();
    }
    update() {
        this.data = this.subject.getState();
    }
}
exports.BranchObserverImpl = BranchObserverImpl;
